import { createAction } from '@ngrx/store';

export const dictionaryChange = createAction('[Dictionary] Translation Change');
export const languageChange = createAction('[Dictionary] Language Change');
